import React from 'react';
import Button from '../../components/Button/Button';

interface BillingSwitcherProps {
  billingInterval: 'month' | 'year';
  onBillingIntervalChange: (interval: 'month' | 'year') => void;
}

const BillingSwitcher: React.FC<BillingSwitcherProps> = ({ 
  billingInterval, 
  onBillingIntervalChange 
}) => {
  return (
    <div className="billing-switcher">
      <Button 
        variant={billingInterval === 'month' ? 'primary' : 'secondary'}
        size="medium"
        onClick={() => onBillingIntervalChange('month')}
      >
        Monthly
      </Button>
      <Button 
        variant={billingInterval === 'year' ? 'primary' : 'secondary'}
        size="medium"
        onClick={() => onBillingIntervalChange('year')}
      >
        Yearly
      </Button>
    </div>
  );
};

export default BillingSwitcher; 